import React, { useState } from "react";
import { useAttributeFormBuilder } from "../../../../Hooks/Display/useComponentProperties";
import EditStepDialog from "../Dialogs/EditStepDialog";
import RemoveStepDialog from "../Dialogs/RemoveStepDialog";

const StepActions = ({ step }) => {
    const [{ steps, selectedStepId }] = useAttributeFormBuilder();
    const [showEditStepDialog, setShowEditStepDialog] = useState(false);
    const [showRemoveStepDialog, setShowDeleteStepDialog] = useState(false);
    const showEditAction = selectedStepId === step.id;
    const showRemoveAction = selectedStepId === step.id && steps.length > 1;
    return (
        <>
            {showEditStepDialog && <EditStepDialog handleClose={() => setShowEditStepDialog(false)} />}
            {showRemoveStepDialog && <RemoveStepDialog handleClose={() => setShowDeleteStepDialog(false)} />}
            {
                showEditAction &&
                <>
                    <span className="k-spacer me-3" />
                    <span onClick={() => setShowEditStepDialog(true)}>
                        <i className="far fa-pencil text-primary font-size-0"></i>
                    </span>
                </>
            }
            {
                showRemoveAction &&
                <>
                    <span className="k-spacer me-3" />
                    <span onClick={() => setShowDeleteStepDialog(true)}>
                        <i className="far fa-xmark text-danger font-size-0"></i>
                    </span>
                </>
            }
        </>
    );
};

export default StepActions;